
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Category } from '@/types/categories';
import { VueNestableHandle } from 'vue-nestable';

@Component({ components: { VueNestableHandle } })
export default class CategoryListTile extends Vue {
  @Prop() category!: Category;
}
